import { render, staticRenderFns } from "./PrinterTabsItems.vue?vue&type=template&id=77860362&scoped=true"
import script from "./PrinterTabsItems.vue?vue&type=script&lang=js"
export * from "./PrinterTabsItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77860362",
  null
  
)

export default component.exports